import { resolveSectionClasses } from "@/storyblok/resolvers";
import { TextBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import { renderRichText } from "@storyblok/js";

export default function TextBlock({ data }: { data: TextBlockData }) {
  return (
    <section
      id={data.anchor}
      className={resolveSectionClasses(data, "container")}
      {...makeEditable(data)}
    >
      <h2 style={{ color: "var(--color-black)" }}>{data.title}</h2>
      <div
        dangerouslySetInnerHTML={{ __html: renderRichText(data.content) }}
      ></div>
    </section>
  );
}
